export function nsI18n(namespace) {
    return {
        computed: {
            t() {
                const raw = this.$i18n.locale;
                const locale = raw && typeof raw === 'object' && 'value' in raw ? raw.value : raw;
                void locale;
                const messages = this.$i18n.messages[locale] || this.$i18n.messages.pt;
                return messages[namespace] || this.$i18n.messages.pt[namespace] || {};
            },
        },
    };
}

export const corporateI18n = nsI18n('corporate');
export const courseGroupsI18n = nsI18n('courseGroups');
export const groupAssignmentsI18n = nsI18n('groupAssignments');
export const adminI18n = nsI18n('admin');
export const studentI18n = nsI18n('student');
